import { render, staticRenderFns } from "./TypingMessage.vue?vue&type=template&id=d2234c84"
import script from "./TypingMessage.vue?vue&type=script&lang=js"
export * from "./TypingMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports